// claims stream: first notice of loss through closure.
export const en: Record<string, string> = {
  "nav.claims": "Claims",
  "claims.title": "Claims",
  "claims.subtitle": "Every loss a customer reported: the carrier's claim number, the adjuster, the money, and each update dated.",
  "claims.filter.open": "Open",
  "claims.filter.closed": "Closed",
  "claims.filter.all": "All",
  "claims.none": "No claims in this view.",
  "claims.add": "Report a claim",
  "claims.customerCard": "Claims",
  "claims.kind": "Type",
  "claims.kind.auto_collision": "Auto collision",
  "claims.kind.auto_comprehensive": "Auto comprehensive",
  "claims.kind.auto_liability": "Auto liability",
  "claims.kind.auto_glass": "Auto glass",
  "claims.kind.property": "Property",
  "claims.kind.liability": "Liability",
  "claims.kind.injury": "Injury",
  "claims.kind.other": "Other",
  "claims.status.reported": "Reported",
  "claims.status.open": "Open",
  "claims.status.under_review": "Under review",
  "claims.status.paid": "Paid",
  "claims.status.closed": "Closed",
  "claims.status.denied": "Denied",
  "claims.policy": "Policy",
  "claims.noPolicy": "No policy",
  "claims.carrier": "Carrier",
  "claims.claimNumber": "Claim #",
  "claims.dateOfLoss": "Date of loss",
  "claims.description": "What happened",
  "claims.adjuster": "Adjuster",
  "claims.adjusterPhone": "Adjuster phone",
  "claims.reserve": "Reserve",
  "claims.paid": "Paid",
  "claims.deductible": "Deductible",
  "claims.updates": "Updates",
  "claims.addUpdate": "Add update",
  "claims.updateNote": "Note",
  "claims.newStatus": "New status",
  "claims.keepStatus": "Keep status",
  "claims.reported": "Claim recorded",
  "claims.updated": "Claim updated",
};

export const es: Record<string, string> = {
  "nav.claims": "Reclamos",
  "claims.title": "Reclamos",
  "claims.subtitle": "Cada siniestro reportado: número de reclamo de la aseguradora, ajustador, montos y cada actualización con fecha.",
  "claims.filter.open": "Abiertos",
  "claims.filter.closed": "Cerrados",
  "claims.filter.all": "Todos",
  "claims.none": "No hay reclamos en esta vista.",
  "claims.add": "Reportar reclamo",
  "claims.customerCard": "Reclamos",
  "claims.kind": "Tipo",
  "claims.kind.auto_collision": "Auto: colisión",
  "claims.kind.auto_comprehensive": "Auto: comprensivo",
  "claims.kind.auto_liability": "Auto: responsabilidad",
  "claims.kind.auto_glass": "Auto: cristales",
  "claims.kind.property": "Propiedad",
  "claims.kind.liability": "Responsabilidad",
  "claims.kind.injury": "Lesiones",
  "claims.kind.other": "Otro",
  "claims.status.reported": "Reportado",
  "claims.status.open": "Abierto",
  "claims.status.under_review": "En revisión",
  "claims.status.paid": "Pagado",
  "claims.status.closed": "Cerrado",
  "claims.status.denied": "Negado",
  "claims.policy": "Póliza",
  "claims.noPolicy": "Sin póliza",
  "claims.carrier": "Aseguradora",
  "claims.claimNumber": "Reclamo #",
  "claims.dateOfLoss": "Fecha del siniestro",
  "claims.description": "Qué pasó",
  "claims.adjuster": "Ajustador",
  "claims.adjusterPhone": "Teléfono del ajustador",
  "claims.reserve": "Reserva",
  "claims.paid": "Pagado",
  "claims.deductible": "Deducible",
  "claims.updates": "Actualizaciones",
  "claims.addUpdate": "Agregar actualización",
  "claims.updateNote": "Nota",
  "claims.newStatus": "Nuevo estado",
  "claims.keepStatus": "Mantener estado",
  "claims.reported": "Reclamo registrado",
  "claims.updated": "Reclamo actualizado",
};
